var e=function(){var e=localStorage.getItem("gaClientId");return e||console.error("Can't get ga client id"),e||""};export{e as getGaClientId};
//# sourceMappingURL=index.js.map
